import axios from 'axios';

const setHeaders = () => {

    axios.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
    axios.defaults.headers.common['X-Frame-Options'] = 'DENY';
    axios.defaults.headers.common['Content-Security-Policy'] = "default-src 'self'";
    axios.defaults.headers.common['X-XSS-Protection'] = '1; mode=block';
    axios.defaults.headers.common['Strict-Transport-Security'] = 'max-age=31536000';
    // axios.defaults.withCredentials = true;
    
};

export default setHeaders;